module.exports = require("/opt/build/repo/src/emotion-cache-props")